/* Signup forms (snippets/signup-form.liquid).
 *
 * 1. Swaps any leftover Omnisend embed placeholders (for example the c11 form
 *    inside product descriptions) for our form, using the <template>s rendered
 *    by snippets/signup-form-templates.liquid. The placeholder element is
 *    replaced, so Omnisend's script (which only loads after cookie consent)
 *    finds nothing to draw into and no duplicate form appears.
 * 2. Handles submit: validates, posts to our backend, shows success or errors.
 */
(function () {
  if (window.__sgSignupReady) return;
  window.__sgSignupReady = true;

  var PLACEHOLDERS = {
    '6941e283452a7f341a989a33': 'footer',
    '67f44445f8fbc713dd3170e7': 'footer',
    '67f7f3301483d5800c84236b': 'sustainability',
    '67ec2b6e1483d5800c841a04': 'c11'
  };

  var MSG = {
    required: 'This field is required',
    email: 'The email address must contain @ and a valid domain',
    failed: 'Something went wrong!',
    processing: 'Processing'
  };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var mountCount = 0;

  function swapPlaceholders() {
    Object.keys(PLACEHOLDERS).forEach(function (formId) {
      var placeholder = document.getElementById('omnisend-embedded-v2-' + formId);
      var tpl = document.getElementById('sg-signup-tpl-' + PLACEHOLDERS[formId]);
      if (!placeholder || !tpl) return;
      var fragment = tpl.content.cloneNode(true);
      // Give the copy unique ids so labels and error messages stay linked.
      var suffix = '-m' + ++mountCount;
      fragment.querySelectorAll('[id]').forEach(function (el) { el.id += suffix; });
      fragment.querySelectorAll('[for]').forEach(function (el) { el.htmlFor += suffix; });
      fragment.querySelectorAll('[aria-describedby]').forEach(function (el) {
        el.setAttribute('aria-describedby', el.getAttribute('aria-describedby') + suffix);
      });
      placeholder.replaceWith(fragment);
    });
  }

  function setError(input, message) {
    var el = document.getElementById(input.getAttribute('aria-describedby'));
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function showSuccess(root, form) {
    var success = root.querySelector('.sg-signup__success');
    // c11: the modal around the form has its own title and text; update those,
    // as the old Omnisend setup did, and hide the form.
    if (root.dataset.source === 'c11') {
      var modal = root.closest('.modal') || root.parentElement;
      var title = modal && modal.querySelector('.modal-title, .modal-headline');
      var text = modal && modal.querySelector('.modal-text, .modal-subheadline');
      if (title && text) {
        title.textContent = success.dataset.successHeading;
        text.innerHTML = success.dataset.successText;
        // Collapse the form but keep its width (see .sg-signup--c11 in the
        // CSS): the product modal sizes itself to its content.
        root.classList.add('sg-signup--collapsed');
        root.setAttribute('inert', '');
        root.setAttribute('aria-hidden', 'true');
        return;
      }
    }
    form.hidden = true;
    success.hidden = false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-sg-signup]')) return;
    event.preventDefault();

    var root = form.closest('[data-sg-root]');
    var email = form.elements.email;
    var name = form.elements.firstName;
    var button = form.querySelector('.sg-signup__button');
    var status = form.querySelector('.sg-signup__status');
    var ok = true;

    status.hidden = true;
    if (name) {
      var nameMissing = name.value.trim() === '';
      setError(name, nameMissing ? MSG.required : '');
      if (nameMissing) ok = false;
    }
    var emailValue = email.value.trim();
    var emailError = emailValue === '' ? MSG.required : (EMAIL_RE.test(emailValue) ? '' : MSG.email);
    setError(email, emailError);
    if (emailError) ok = false;
    if (!ok) {
      (name && name.getAttribute('aria-invalid') === 'true' ? name : email).focus();
      return;
    }

    button.disabled = true;
    button.textContent = MSG.processing;

    fetch(form.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        source: form.dataset.source,
        email: emailValue,
        firstName: name ? name.value.trim() : undefined,
        website: form.elements.website.value
      })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (res.ok && data.ok) {
            showSuccess(root, form);
            // Omnisend's script is only on the page after the visitor accepted
            // cookies; in that case link this browser to the new contact.
            if (window.omnisend && typeof window.omnisend.identifyContact === 'function') {
              try { window.omnisend.identifyContact({ email: emailValue.toLowerCase() }); } catch (e) {}
            }
            return;
          }
          if (data.error === 'email') { setError(email, MSG.email); email.focus(); return; }
          if (data.error === 'first_name' && name) { setError(name, MSG.required); name.focus(); return; }
          throw new Error(data.error || 'failed');
        });
      })
      .catch(function () {
        status.textContent = MSG.failed;
        status.hidden = false;
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = button.dataset.label;
      });
  });

  swapPlaceholders();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapPlaceholders);
  }
})();
